import ga4 from "../lib/ga-helper.js";

$(function () {
    function getDefaultLinkParams($el) {
        let link_text = $el.find(".js-ga4-title").text();
        link_text = link_text ? link_text : $el.text();
        return {
            link_url: $el.attr("href"),
            link_text,
        };
    }
    $('a[target="_blank"]').on("click", function () {
        const $el = $(this);
        ga4.trackEvnt("outbound_links", getDefaultLinkParams($el));
    });
    $("main a").on("click", function () {
        const $el = $(this);
        if ($el.attr("href")) {
            ga4.trackEvnt("content_links", getDefaultLinkParams($el));
        }
    });
    $("a").on("click", function () {
        const $el = $(this);
        ga4.trackEvnt("All Links", getDefaultLinkParams($el));
    });

    /* --- New user journey contact form GA4 implementation 11/07/24 --- */

    // contact_triage_topics
    $(".userjourneycontactpage .contact-filter-dropdown-link").on(
        "click",
        function () {
            const $el = $(this);
            ga4.trackEvnt("contact_triage_topics", {
                triage_option: $el.text(),
            });
        }
    );

    // contact_triage_content
    $(".userjourneycontactpage .waiter-results .accordion-item a").on(
        "click",
        function () {
            ga4.trackEvnt(
                "contact_triage_content",
                getDefaultLinkParams($(this))
            );
        }
    );

    // contact_tabs_reveal
    $(".userjourneycontactpage .waiter-results-callout__button").on(
        "click",
        function () {
            ga4.trackEvnt("contact_tabs_reveal", { link_text: $(this).text() });
        }
    );

    // contact_tabs_active
    $(".userjourneycontactpage .waiter-results-tabs li a").on(
        "click",
        function () {
            ga4.trackEvnt("contact_tabs_active", { link_text: $(this).text() });
        }
    );

    // contact_us_form
    $(".userjourneycontactpage .waiter-results-tabs-panel form").on(
        "submit",
        function () {
            ga4.trackEvnt("contact_us_form");
        }
    );

    // contact_tabs_content
    $(".userjourneycontactpage .tabs-content a").on("click", function () {
        ga4.trackEvnt("contact_tabs_content", getDefaultLinkParams($(this)));
    });

    // contact_leadcapture_trigger
    $(".userjourneycontactpage .contact-callout button").on(
        "click",
        function () {
            ga4.trackEvnt("contact_leadcapture_trigger", {
                link_text: $(this).text(),
            });
        }
    );
});
